import { ZigzagEvent } from '@common/log-manager';

export const useMaximumBenefitLog = () => {
  const pageviewMaximumBenefitUBL = (catalog_product_id: string, max_benefit_price: number, benefit_type: string) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'section',
      object_section: 'max_benefit_price',
      data: JSON.stringify({ catalog_product_id, max_benefit_price, benefit_type }),
    });
  };

  const impressionCouponDownloadUBL = (catalog_product_id: string, coupon_id: string, issuable: boolean) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'button',
      object_section: 'max_benefit_price',
      object_id: 'seller_coupon',
      data: JSON.stringify({ catalog_product_id, coupon_id, download: issuable ? 'available' : 'unavailable' }),
    });
  };

  const clickCouponDownloadUBL = (catalog_product_id: string, coupon_id: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_section: 'max_benefit_price',
      object_id: 'seller_coupon',
      data: JSON.stringify({ catalog_product_id, coupon_id }),
    });
  };

  const clickDropDownUBL = (catalog_product_id: string, object_id: 'down' | 'up') => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_section: 'max_benefit_price',
      object_id: object_id,
      data: JSON.stringify({ catalog_product_id }),
    });
  };

  const clickBenefitItemToggleUBL = (catalog_product_id: string, object_id: 'on' | 'off', benefit_type: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_section: 'max_benefit_price',
      object_id: object_id,
      data: JSON.stringify({ catalog_product_id, benefit_type }),
    });
  };

  return {
    pageviewMaximumBenefitUBL,
    impressionCouponDownloadUBL,
    clickCouponDownloadUBL,
    clickDropDownUBL,
    clickBenefitItemToggleUBL,
  };
};
